/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ExamListForItemRepositoryResponse } from "../types/ExamListForItemRepositoryResponse.ts";

export const examListForItemRepositoryResponseSchema = z.object({
  id: z.optional(z.number().int().describe("ID da prova.")),
  title: z.string().describe("Título da prova.").nullish(),
  disciplineId: z
    .number()
    .int()
    .describe("ID da disciplina associada à prova. Opcional.")
    .nullish(),
  disciplineCode: z
    .string()
    .describe("Código da disciplina associada à prova. Opcional.")
    .nullish(),
  disciplineText: z
    .string()
    .describe("Nome da disciplina associada à prova. Opcional.")
    .nullish(),
  examType: z.optional(
    z
      .number()
      .int()
      .describe(
        "Tipo da prova. Enum EExamType: `0` = StudentEvaluation, `1` = TeacherEvaluation, `2` = InstructorEvaluation, `3` = MonographQuestionnaire, `4` = Challenge, `5` = Qualification, `6` = Scholarship, `7` = Entrance.",
      ),
  ),
  examTypeText: z
    .string()
    .describe("Descrição textual do tipo da prova. Opcional.")
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se a prova está ativa.")),
  creationDate: z
    .string()
    .datetime()
    .describe("Data de criação da prova. Opcional.")
    .nullish(),
  lastChangeDate: z
    .string()
    .datetime()
    .describe("Data da última alteração da prova. Opcional.")
    .nullish(),
  examLangId: z
    .number()
    .int()
    .describe("ID do idioma da prova. Opcional.")
    .nullish(),
  recommendedToDoOnPortal: z.optional(
    z
      .boolean()
      .describe(
        "Indica se a prova é recomendada para ser realizada pelo portal.",
      ),
  ),
  enableSafeEvaluationMode: z.optional(
    z
      .boolean()
      .describe(
        "Indica se o modo de avaliação segura está habilitado para a prova.",
      ),
  ),
  maxScreenExitsAllowed: z
    .number()
    .int()
    .describe(
      "Número máximo de saídas de tela permitidas durante a realização da prova no modo seguro. Opcional.",
    )
    .nullish(),
}) as unknown as ToZod<ExamListForItemRepositoryResponse>;
